/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_Reason_Customer_No_Longer_NeedsInputs */

const vi_einvoice_skip_reason_customer_no_longer_needs = /** @type {(inputs: Einvoice_Skip_Reason_Customer_No_Longer_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách không cần nữa`)
};

/**

* @param {Einvoice_Skip_Reason_Customer_No_Longer_NeedsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_reason_customer_no_longer_needs = /** @type {((inputs?: Einvoice_Skip_Reason_Customer_No_Longer_NeedsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_Reason_Customer_No_Longer_NeedsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_reason_customer_no_longer_needs(inputs)
});